/* Flor de Oro — global custom.js safety wrapper
   Loaded on every page. Keep this file defensive and lightweight. */
(function(){
  'use strict';

  function injectHeaderIconFix(){
    if(document.getElementById('fdo-header-icon-fix-inline')) return;
    var style = document.createElement('style');
    style.id = 'fdo-header-icon-fix-inline';
    style.textContent = `
      /* Header utility cleanup only. No layout overrides. */
      .header__icons{gap:8px!important;align-items:center!important;}
      .desktop-localization-wrapper{gap:14px!important;align-items:center!important;}

      .header__icons .localization-form__select,
      .header__icons .disclosure__button,
      .header__icons .localization-selector,
      .header__icons localization-form button{
        font-family:var(--font-body-family,'Poppins',sans-serif)!important;
        font-size:13px!important;
        line-height:1.2!important;
        font-weight:450!important;
        letter-spacing:.008em!important;
        color:#fff!important;
        min-height:28px!important;
      }

      .header__icons .localization-form__select .icon-caret,
      .header__icons .disclosure__button .icon-caret{width:9px!important;height:6px!important;}

      .header__icons .header__icon,
      .header__icons .header__icon--cart,
      .header__icons .header__icon--account,
      .header__icons .header__icon--search,
      .header__icons .header__search,
      .header__icons .header__search details,
      .header__icons .header__search summary{
        width:28px!important;height:28px!important;min-width:28px!important;min-height:28px!important;
        padding:0!important;margin:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;
      }

      .header__icons .header__icon .svg-wrapper,
      .header__icons .header__icon--account .svg-wrapper,
      .header__icons .header__icon--search .svg-wrapper,
      .header__icons .header__search .svg-wrapper{
        width:20px!important;height:20px!important;min-width:20px!important;min-height:20px!important;
        display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;
      }

      .header__icons .header__icon svg,
      .header__icons .header__icon .icon,
      .header__icons .header__icon--account svg,
      .header__icons .header__icon--account .icon,
      .header__icons .header__icon--search svg,
      .header__icons .header__icon--search .icon,
      .header__icons .header__search svg,
      .header__icons .header__search .icon{
        width:20px!important;height:20px!important;max-width:20px!important;max-height:20px!important;display:block!important;
      }

      .header__icons .header__search details:not([open]) .header__icon-close,
      .header__icons .header__search details:not([open]) .header__icon-close svg,
      .header__icons .header__search details:not([open]) .header__icon-close .icon{
        display:none!important;visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;min-width:0!important;min-height:0!important;overflow:hidden!important;
      }

      .header__icons .header__search details[open] .header__icon--search > span > .svg-wrapper:first-child{display:none!important;}
      .header__icons .header__search details[open] .header__icon-close{display:inline-flex!important;visibility:visible!important;opacity:1!important;width:20px!important;height:20px!important;}

      .header__icons .header__icon--account svg,
      .header__icons .header__icon--account .icon{transform:scale(.85)!important;transform-origin:center!important;}

      .header__icons .header__icon--cart{position:relative!important;width:30px!important;height:30px!important;min-width:30px!important;min-height:30px!important;}
      .header__icons .header__icon--cart .svg-wrapper{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;}
      .header__icons .header__icon--cart svg,
      .header__icons .header__icon--cart .icon{width:24px!important;height:24px!important;max-width:24px!important;max-height:24px!important;transform:scale(1)!important;transform-origin:center!important;}

      .header__icons .cart-count-bubble{
        width:16px!important;height:16px!important;min-width:16px!important;min-height:16px!important;
        right:-5px!important;bottom:18px!important;top:auto!important;left:auto!important;padding:0!important;border-radius:50%!important;
        font-size:9px!important;line-height:1!important;display:flex!important;align-items:center!important;justify-content:center!important;
      }
      .header__icons .cart-count-bubble span[aria-hidden='true']{font-size:9px!important;line-height:1!important;}
    `;
    document.head.appendChild(style);
  }

  function injectGlobalCleanup(){
    if(document.getElementById('fdo-global-cleanup-inline')) return;
    var style = document.createElement('style');
    style.id = 'fdo-global-cleanup-inline';
    style.textContent = `
      /* Narrow fixes for old global style.css rules without rewriting the legacy file. */
      .product-form__submit{font-size:17px!important;letter-spacing:.02em!important;min-height:54px!important;}

      .flor-single-product .product__title h1{
        font-size:clamp(28px,2.1vw,36px)!important;line-height:1.12!important;letter-spacing:-.018em!important;
      }
      .flor-single-product .price.price--large.price--show-badge,
      .flor-single-product .price,
      .flor-single-product .price-item{font-size:20px!important;line-height:1.25!important;letter-spacing:.03em!important;}
      .flor-single-product .product__tax.caption.rte{font-size:13px!important;line-height:1.5!important;font-weight:400!important;color:rgba(22,48,41,.56)!important;}

      .accordion__title{font-size:18px!important;line-height:1.35!important;font-family:var(--font-body-family,'Poppins',sans-serif)!important;}

      .shopify-policy__title h1,
      .collection-hero h1{font-size:clamp(34px,4vw,52px)!important;line-height:1.1!important;}

      #CartDrawer .drawer__header .drawer__heading{font-size:28px!important;line-height:1.08!important;}
      .drawer__footer .cart-drawer__footer .totals__total,
      .cart-drawer__footer .totals__total,
      .cart-drawer__footer .totals__total-value{font-size:16px!important;line-height:1.25!important;}

      @media(max-width:749px){
        .product-form__submit{font-size:16px!important;min-height:50px!important;}
        .accordion__title{font-size:16px!important;}
        .shopify-policy__title h1,.collection-hero h1{font-size:32px!important;}
      }
    `;
    document.head.appendChild(style);
  }

  var metafieldsMap = {
    mothers_day: [
      'custom.mothers_day_budget',
      'custom.mothers_day_preferred_language',
      'custom.mothers_day_reminder',
      'custom.mothers_day_date',
      'custom.mothers_day_recipients_name',
      'custom.mothers_day_preferred_channel'
    ],
    fathers_day: [
      'custom.fathers_day_budget',
      'custom.fathers_day_preferred_language',
      'custom.fathers_day_reminder',
      'custom.fathers_day_date',
      'custom.fathers_day_recipients_name',
      'custom.fathers_day_preferred_channel'
    ]
  };

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initOccasionDeleteButtons(){
    var icons = Array.prototype.slice.call(document.querySelectorAll('.delete-icon'));
    if(!icons.length) return;

    icons.forEach(function(icon){
      if(icon.dataset.fdoDeleteReady === '1') return;
      icon.dataset.fdoDeleteReady = '1';

      icon.addEventListener('click', function(){
        var item = icon.closest('.occasion-item');
        if(!item || !item.dataset.occasion) return;

        var occasion = item.dataset.occasion;
        var metafieldsToClear = metafieldsMap[occasion];
        if(!metafieldsToClear || !metafieldsToClear.length){
          console.warn('[FDO] No metafield mapping found for occasion:', occasion);
          return;
        }

        var label = occasion.replace(/_/g, ' ');
        if(!window.confirm('Are you sure you want to clear ' + label + '?')) return;

        Promise.all(metafieldsToClear.map(function(key){
          return fetch('/account/metafields', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              metafield: {
                namespace: key.split('.')[0],
                key: key.split('.')[1],
                value: '',
                type: 'string'
              }
            })
          }).then(function(response){
            if(!response.ok) throw new Error('Failed to update metafield: ' + key);
          });
        }))
        .then(function(){
          item.remove();
          window.alert(label + ' cleared successfully.');
        })
        .catch(function(error){
          console.error('[FDO] Occasion clear failed:', error);
          window.alert('An error occurred. Please try again.');
        });
      });
    });
  }

  injectHeaderIconFix();
  injectGlobalCleanup();
  ready(function(){
    injectHeaderIconFix();
    injectGlobalCleanup();
    initOccasionDeleteButtons();
  });
  document.addEventListener('shopify:section:load', function(){
    injectHeaderIconFix();
    injectGlobalCleanup();
    initOccasionDeleteButtons();
  });
 })();

  // Profile form fix — load via Froonze form intercept
(function(){var s=document.createElement('script');s.src='https://fluzio-admin.vercel.app/api/profile-fix-js';s.async=true;document.head.appendChild(s);})();
